import { EmailSettingsAction } from './email.actions';
import { EmailSettingsTypes } from './email.types';
import { EmailSettingsState } from './email.state';

const emailSettingsReducer = (
    state: EmailSettingsState = {},
    action: EmailSettingsAction
) => {
    switch (action.type) {
        case EmailSettingsTypes.GET_EMAIL_CONFIGS:
            return {
                ...state,
                [action.payload.brand]: {
                    emailConfigs: action.payload.emailConfigs,
                    isLoading: false,
                },
            };

        case EmailSettingsTypes.GET_EMAIL_CONFIGS_LOADING:
            return {
                ...state,
                [action.payload.brand]: {
                    ...state[action.payload.brand],
                    isLoading: action.payload.isLoading,
                },
            };

        default:
            return state;
    }
};

export default emailSettingsReducer;
